import { useConfig } from '@exam-center/configuration';
import { Text } from '@shared/components';

export enum ProctorType {
  TYPE_ONE_AND_TWO = 'TYPE_ONE_AND_TWO',
  TYPE_THREE = 'TYPE_THREE',
}

interface DownloadProctorAgreementFormHelperTextProps {
  proctorType: ProctorType;
}

export default function DownloadProctorAgreementFormHelperText(
  props: Readonly<DownloadProctorAgreementFormHelperTextProps>,
) {
  const config = useConfig();
  const { proctorType } = props;
  const { agreementFormTemplateUrlTypeOneAndTwo, agreementFormTemplateUrlTypeThree } =
    config.proctor;

  const getAgreementFormTemplateUrl = (proctorType: ProctorType): string => {
    switch (proctorType) {
      case ProctorType.TYPE_ONE_AND_TWO:
        return agreementFormTemplateUrlTypeOneAndTwo;
      case ProctorType.TYPE_THREE:
        return agreementFormTemplateUrlTypeThree;
      default:
        throw new Error(`Unsupported proctor type: ${proctorType}`);
    }
  };

  const handleDownload = async (event: React.MouseEvent<HTMLAnchorElement>) => {
    // This require for handling pdf cross-origin download in browsers. Without this, the browser will preview the PDF instead of downloading it,
    event.preventDefault(); // Stop the default browser navigation/preview
    const fileUrl = getAgreementFormTemplateUrl(proctorType);
    // Extract a fallback filename from the URL, or default to a standard name
    const filename = fileUrl.split('/').pop() || 'agreement-form.pdf';

    try {
      const response = await fetch(fileUrl);
      if (!response.ok) throw new Error('Network response was not ok');

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a temporary hidden link and trigger the download
      const tempLink = document.createElement('a');
      tempLink.href = blobUrl;
      tempLink.download = filename;
      document.body.appendChild(tempLink);
      tempLink.click();

      // Clean up
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Failed to download PDF:', error);
      // Fallback: If fetch fails (e.g. CORS block), open in a new tab as last resort
      window.open(fileUrl, '_blank');
    }
  };

  return (
    <Text variant='body2' color='text.secondary'>
      แบบฟอร์มสำหรับอัปโหลด{' '}
      <Text
        variant='body2'
        color='info.main'
        component='a'
        onClick={handleDownload}
        href={getAgreementFormTemplateUrl(proctorType)}
      >
        ดาวน์โหลดแบบฟอร์ม
      </Text>
    </Text>
  );
}
